"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCarousel = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CarouselMixin = require("../../mixins/components/CarouselMixin");
var StyledCarousel = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledCarousel",
  componentId: "c11n-8-107-0__sc-ibkoes-0"
})(["", ""], _CarouselMixin.CarouselMixin);
exports.StyledCarousel = StyledCarousel;